// extracted by mini-css-extract-plugin
export var buttonContainer = "_a1-1";
export var fontSizeSelect = "_a1-3";
export var formatSelect = "_a1-2";
export var formats = "_a1-4";
export var hidden = "_a1-5";
export var icon = "_a1-6";
export var select = "_a1-0";